import { render, staticRenderFns } from "./ImageCard.vue?vue&type=template&id=4580ca56&scoped=true&"
import script from "./ImageCard.vue?vue&type=script&lang=ts&"
export * from "./ImageCard.vue?vue&type=script&lang=ts&"
import style0 from "./ImageCard.vue?vue&type=style&index=0&id=4580ca56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4580ca56",
  null
  
)

export default component.exports